import { Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import { CountLabelModel } from '../../models/cont-label.model';


@Component({
    selector: 'app-dashboard-stats-counts',
    templateUrl: './dashboard-stats-counts.component.html',
    standalone: false
})
export class DashboardStatsCountsComponent implements OnInit {

  @Input() statsAndCount: CountLabelModel;

  @Output() redirection: EventEmitter<any> = new EventEmitter<any>();
  constructor() { }

  ngOnInit() { }

  redirectTo(url, status) {
    this.redirection.emit({ url: url, status: status });
  }

}
